import { permissionsMock } from "./user/permissions";
import { bookingMock } from "./bookings/bookings";
import MockAdapter from "axios-mock-adapter";
import { AxiosStatic } from "axios";
import errorMock from "./general/errors";
import { orderMock } from "./orders/order";
import { indexOfficesMock } from "./offices";
import { loginMock } from "./user/login";
import { logoutMock } from "./user/logout";
import appSettingsMock from "./general/appSettings";
import { recordStampMock } from "./recordStamps/recordStamp";
import { filtersMock } from "./filters/filter";
import { documentsMock } from "./documents/documents";
import { financesMock } from "./finances/finances";

const mockFactory = (axios: AxiosStatic): void => {
  const mock = new MockAdapter(axios, { delayResponse: 300 });
  errorMock(mock);
  appSettingsMock(mock);
  orderMock(mock);
  bookingMock(mock);
  indexOfficesMock(mock);
  loginMock(mock);
  logoutMock(mock);
  permissionsMock(mock);
  recordStampMock(mock);
  filtersMock(mock);
  documentsMock(mock);
  financesMock(mock);
};

export { mockFactory };

export default mockFactory;
